const CONTENT_SOURCE = Object.freeze({
  FIELD: 'field',
  RICHTEXT: 'richText'
})

const RICHTEXT_TYPE = Object.freeze({
  ASSET: 'asset',
  CONTENT: 'content',
  TEXT: 'text'
})

const VARIABLE_TYPE = Object.freeze({
  ARRAY: 'array',
  NUMBER: 'number',
  OBJECT: 'object',
  STRING: 'string'
})

const PAGE_TEMPLATES = {
  GLOSSARY_PAGE: 'GlossaryPage',
  LANDING_PAGE: 'LandingPage',
  PARTNER_PAGE: 'PartnerPage',
  PARTNER_LIST_PAGE: 'PartnerListPage'
}

const PAGE_TYPES = {
  homePage: 'home-page',
  productPage: 'product-page',
  contentPage: 'content-page'
}

const PRODUCTS = {
  consumerLoan: 'loans',
  Electricity: 'electricity',
  EPI: 'epi',
  Insurance: 'car-insurance',
  Mortgage: 'loans',
  SME: 'loans'
}

export {
  CONTENT_SOURCE,
  PAGE_TEMPLATES,
  PAGE_TYPES,
  PRODUCTS,
  RICHTEXT_TYPE,
  VARIABLE_TYPE
}
